import { useState } from 'react';
import { useDemoCtx } from '../DemoContext';

export function IrrForm({ siteName = '전체' }: { siteName?: string }) {
    const { toast, closePanel } = useDemoCtx();
    const [amt, setAmt] = useState(760);
    const now = new Date().toISOString().slice(0, 16);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '11px 14px', background: 'var(--primary-light)', border: '1.5px solid var(--primary-mid)', borderRadius: 9, marginBottom: 4 }}>
                <span style={{ fontSize: 15 }}>🌲</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--primary-dark)' }}>{siteName}</span>
            </div>
            <div className="form-group">
                <label className="form-label">관수 일시 <span style={{ color: 'var(--danger)' }}>*</span></label>
                <input type="datetime-local" className="form-input" defaultValue={now} />
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">관수량 (Liter) <span style={{ color: 'var(--danger)' }}>*</span></label>
                    <input type="number" className="form-input" value={amt} onChange={e => setAmt(Number(e.target.value))} />
                </div>
                <div className="form-group">
                    <label className="form-label">mm 환산</label>
                    <input type="text" className="form-input" readOnly value={`≈ ${(amt / 280).toFixed(1)}mm`} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">관수 방법</label>
                    <select className="form-select"><option>스프링클러</option><option>점적관수</option><option>수동</option><option>자동관개</option></select>
                </div>
                <div className="form-group">
                    <label className="form-label">관수 시간 (분)</label>
                    <input type="number" className="form-input" defaultValue={45} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label className="form-label">작업자</label>
                    <select className="form-select"><option>김관리자</option><option>박현장</option><option>이담당</option></select>
                </div>
                <div className="form-group">
                    <label className="form-label">작업 인원</label>
                    <input type="number" className="form-input" defaultValue={2} min={1} />
                </div>
            </div>
            <div className="form-group">
                <label className="form-label">특이사항</label>
                <textarea className="form-textarea" placeholder="관수 후 상태, 특이 관찰 사항 등" />
            </div>
            <div className="form-group">
                <label className="form-label">현장 사진 (최대 5장)</label>
                <div className="photo-drop" onClick={() => toast('파일 선택', 'success')}>
                    <div className="photo-drop-ico">📷</div>
                    <div className="photo-drop-txt">클릭 또는 파일 드래그 앤 드롭</div>
                </div>
            </div>
            <div className="water-calc">
                <div className="wc-row"><span className="wc-lbl">현재 토양 수분율</span><span className="wc-val">41%</span></div>
                <div className="wc-row"><span className="wc-lbl">관수량 ({amt}L)</span><span className="wc-val">+{(amt / 280).toFixed(1)}mm</span></div>
                <div className="wc-row"><span className="wc-lbl">자연 증발 손실</span><span className="wc-val">-0.8%</span></div>
                <div className="wc-row"><span className="wc-lbl">관수 후 예상 수분율</span><span className="wc-val" style={{ color: 'var(--good)' }}>≈ {Math.min(99, 41 + Math.round(amt / 50))}%</span></div>
            </div>
            <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                <button className="btn btn-ghost" style={{ flex: 1 }} onClick={closePanel}>취소</button>
                <button className="btn btn-primary" style={{ flex: 2 }} onClick={() => { toast('관수가 등록되었습니다! 수분 모델 재계산 중... ✓', 'success'); closePanel(); }}>관수 등록 완료</button>
            </div>
        </div>
    );
}
